// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import request from '@/api/request';

/**
 * @description 配置分类 -- 编辑表单
 */
export function updateConfigClassifyTable(id: number | string) {
    return request({
        url: `config/classify/update/table/${id}`,
        method: 'get',
    });
}

/**
 * @description 配置分类 -- 添加表单
 */
export function createConfigClassifyTable() {
    return request({
        url: 'config/classify/create/table',
        method: 'get',
    });
}

/**
 * @description 配置分类 -- 列表
 */
export function configClassifyLst(status: number|string, classifyName: string, page: number, limit: number) {
    return request({
        url: 'config/classify/lst',
        method: 'get',
        params: { page, limit, status, classifyName },
    });
}

/**
 * @description 配置分类 -- 修改状态
 */
export function changeConfigClassifyStatus(id: number | string, status: number) {
    return request({
        url: `config/classify/status/${id}`,
        method: 'post',
        data: { status },
    });
}

/**
 * @description 配置分类 -- 删除
 */
export function classifyDelApi(id: number | string) {
    return request({
        url: `config/classify/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 配置分类 -- 列表
 */
export function configClassifyOptions() {
    return request({
        url: 'config/classify/options',
        method: 'get',
    });
}

/**
 * @description 配置 -- 删除
 */
export function settingDelApi(id: number | string) {
    return request({
        url: `config/setting/delete/${id}`,
        method: 'delete',
    });
}

export function updateConfigSettingTable(id: number | string) {
    return request({
        url: `config/setting/update/table/${id}`,
        method: 'get',
    });
}

export function createConfigSettingTable(data: any) {
    return request({
        url: 'config/setting/create/table',
        method: 'get',
        params: data,
    });
}

export function configSettingLst(data: any) {
    return request({
        url: 'config/setting/lst',
        method: 'get',
        params: data,
    });
}

export function changeConfigSettingStatus(id: number | string, status: number) {
    return request({
        url: `config/setting/status/${id}`,
        method: 'post',
        data: { status },
    });
}

export function groupLst(page: number, limit: number) {
    return request({
        url: 'group/lst',
        method: 'get',
        params: { page, limit },
    });
}

export function createGroupTable() {
    return request({
        url: 'group/create/table',
        method: 'get',
    });
}

export function updateGroupTable(id: number | string) {
    return request({
        url: `group/update/table/${id}`,
        method: 'get',
    });
}

/**
 * @description 数据列表 -- 表格表头
 */
export function groupDetail(id: number | string) {
    return request({
        url: `group/detail/${id}`,
        method: 'get',
    });
}

/**
 * @description 数据列表 -- 列表
 */
export function groupDataLst(groupId: number | string, page: number, limit: number) {
    return request({
        url: `group/data/lst/${groupId}`,
        method: 'get',
        params: { page, limit },
    });
}

/**
 * @description 数据列表 -- 新增表单
 */
export function createGroupData(groupId: number | string) {
    return request({
        url: `group/data/create/table/${groupId}`,
        method: 'get',
    });
}

/**
 * @description 数据列表 -- 编辑表单
 */
export function updateGroupData(groupId: number | string, id: number | string) {
    return request({
        url: `group/data/update/table/${groupId}/${id}`,
        method: 'get',
    });
}

/**
 * @description 数据列表 -- 修改状态
 */
export function statusGroupData(id: number | string, data: any) {
    return request({
        url: `group/data/status/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 数据列表 -- 删除
 */
export function deleteGroupData(id: number | string) {
    return request({
        url: `group/data/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 菜单管理 -- 列表
 */
export function menuListApi(data: any) {
    return request({
        url: 'system/menu/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 菜单管理 -- 新增表单
 */
export function menuCreateApi(query?: Record<string, unknown>) {
    return request({
        url: 'system/menu/create/form',
        method: 'get',
        params: query,
    });
}

/**
 * @description 菜单管理 -- 编辑表单
 */
export function menuUpdateApi(id: number | string, query?: Record<string, unknown>) {
    return request({
        url: `system/menu/update/form/${id}`,
        method: 'get',
        params: query,
    });
}

/**
 * @description 菜单管理 -- 删除
 */
export function menuDeleteApi(id: number | string) {
    return request({
        url: `system/menu/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 附件分类 -- 所有分类
 */
export function formatLstApi() {
    return request({
        url: 'system/attachment/category/formatLst',
        method: 'get',
    });
}

/**
 * @description 附件分类 -- 添加分类
 */
export function attachmentCreateApi() {
    return request({
        url: 'system/attachment/category/create/form',
        method: 'get',
    });
}

/**
 * @description 附件分类 -- 编辑分类
 */
export function attachmentUpdateApi(id: number | string) {
    return request({
        url: `system/attachment/category/update/form/${id}`,
        method: 'get',
    });
}

/**
 * @description 附件分类 -- 编辑名称
 */
export function picNameUpdateApi(id: number | string) {
    return request({
        url: `system/attachment/update/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 附件分类 -- 编辑名称升级
 */
export function picNameEditApi(id: number | string, data: any) {
    return request({
        url: `system/attachment/update/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 附件分类 -- 删除分类
 */
export function attachmentDeleteApi(id: number | string) {
    return request({
        url: `system/attachment/category/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 图片列表
 */
export function attachmentListApi(data: any) {
    return request({
        url: 'system/attachment/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 图片列表 -- 删除
 */
export function picDeleteApi(ids:any) {
    return request({
        url: 'system/attachment/delete',
        method: 'delete',
        data:ids ,
    });
}

/**
 * @description 图片列表 -- 修改附件分类
 */
export function categoryApi(ids: any, attachmentCategoryId: number | string) {
    return request({
        url: 'system/attachment/category',
        method: 'post',
        data: { ids, attachmentCategoryId },
    });
}

/**
 * @description 公告列表 -- 创建
 */
export function createNotice(data: any) {
    return request({
        url: 'notice/create',
        method: 'post',
        data,
    });
}

/**
 * @description 公告列表 -- 列表
 */
export function stationNewsList(data: any) {
    return request({
        url: 'notice/lst',
        method: 'get',
        params: data,
    });
}



/**
 * @description 公告列表 -- 详情
 */
export function noticeDetail(id:number | string) {
    return request({
        url: `notice/detail/${id}`,
        method: 'get',
    });
}
/**
 * @description 公告列表 -- 更新
 */
export function noticeUpdateApi(id:number, data:any) {
    return request({
        url: `notice/update/${id}`,
        method: 'post',
        data,
    });

}

/**
 * @description 公告列表 -- 修改状态
 */
export function noticeSwitchStatusApi(id:number, status:number) {
    return request({
        url: `notice/switchStatus/${id}`,
        method: 'post',
    data:{status},
    });
}

/**
 * @description 公告列表 -- 删除
 */
export function noticeDeleteApi(id:number) {
    return request({
        url: `notice/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 消息提示 -- 待办
 */
export function needDealtList() {
    return request({
        url: 'statistics/get_admin_todo',
        method: 'get',
    });
}

/**
 * @description 配置
 */
export function configApi() {
    return request({
        url: 'config',
        method: 'get',
    });
}

/**
 * @description 客服管理 -- 创建表单
 */
export function serviceCreateApi() {
    return request({
        url: 'service/create/form',
        method: 'get',
    });
}

/**
 * @description 客服管理 -- 编辑表单
 */
export function serviceUpdateApi(id: number | string) {
    return request({
        url: `service/update/form/${id}`,
        method: 'get',
    });
}

/**
 * @description 客服管理 -- 列表
 */
export function serviceListApi(data: any) {
    return request({
        url: 'service/list',
        method: 'get',
        params: data,
    });
}

/**
 * @description 客服管理 -- 修改状态
 */
export function serviceStatusApi(id: number | string, status: number) {
    return request({
        url: `service/status/${id}`,
        method: 'post',
        data: { status },
    });
}

/**
 * @description 客服管理 -- 删除
 */
export function serviceDeleteApi(id: number | string) {
    return request({
        url: `service/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 客服管理 -- 用户列表
 */
export function userLstApi(data: any) {
    return request({
        url: 'service/user_lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 客服管理 -- 用户列表
 */
export function userListApi(data: any) {
    return request({
        url: 'user/list',
        method: 'get',
        params: data,
    });
}

/**
 * @description 客服管理 -- 用户列表
 */
export function serviceChatListApi(id: number | string, data: any) {
    return request({
        url: `service/${id}/user`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 客服管理 -- 客服与用户的聊天记录
 */
export function serviceChatUidListApi(id: number | string, uid: number | string, data: any) {
    return request({
        url: `service/${id}/${uid}/lst`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 客服管理 -- 登录（可选传 merId，与后端校验一致）
 */
export function serviceLoginApi(id: number | string, merId?: number) {
    return request({
        url: `service/login/${id}`,
        method: 'post',
        params: merId != null && merId !== undefined ? { merId } : {},
    });
}

/**
 * @description 滑块 -- 请求滑块验证码
 */
export function ajCaptcha(data: any) {
    return request({
        url: 'ajcaptcha',
        method: 'get',
        params: data,
    });
}

/**
 * @description 滑块 -- 请求滑块验证码
 */
export function ajCaptchaCheck(data: any) {
    return request({
        url: 'ajcheck',
        method: 'post',
        data,
    });
}

/**
 * @description 滑块 -- 请求滑块验证码
 */
export function ajCaptchaStatus(data: any) {
    return request({
        url: 'ajstatus',
        method: 'post',
        data,
    });
}

/**
 * @description 城市数据 -- 添加
 */
export function cityDataCreate(id: number | string) {
    return request({
        url: `store/city/create/form/${id}`,
        method: 'get',
    });
}

/**
 * @description 城市数据 -- 编辑
 */
export function cityDataUpdate(id: number | string) {
    return request({
        url: `store/city/update/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 城市数据 -- 列表
 */
export function cityDataLst(id: number | string) {
    return request({
        url: `store/city/lst/${id}`,
        method: 'get',
    });
}

/**
 * @description 城市数据 -- 删除
 */
export function cityDataDelete(id: number | string) {
    return request({
        url: `store/city/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 数据配置 -- 菜单
 */
export function groupAllApi() {
    return request({
        url: 'diy/get_theme_key',
        method: 'get',
    });
}

/**
 * @description 数据配置 -- 列表数据
 */
export function groupDataListApi(key: string, data: any) {
    return request({
        url: `diy/get_theme/${key}`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 数据配置 -- 连续签到奖励(添加)
 */
export function groupDataAddApi(id: number | string) {
    return request({
        url: `group/data/create/table/${id}`,
        method: 'get',
    });
}

/**
 * @description 数据配置 -- 连续签到奖励(删除)
 */
export function groupDataDeleteApi(id: number | string) {
    return request({
        url: `group/data/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 数据配置 -- 连续签到奖励(编辑)
 */
export function groupDataEditApi(groupId: number | string, groupDataId: number | string) {
    return request({
        url: `group/data/update/table/${groupId}/${groupDataId}`,
        method: 'get',
    });
}

/**
 * @description 数据配置 -- 列表数据(保存)
 */
export function groupSaveApi(key: string, data: any) {
    return request({
        url: `diy/set_theme/${key}`,
        method: 'post',
        data,
    });
}

/**
 * @description 客服管理 -- 修改状态
 */
export function groupDataSetApi(id: number | string, status: number) {
    return request({
        url: `group/data/status/${id}`,
        method: 'post',
        data: { status },
    });
}

/**
 * @description 专题活动 -- 创建
 */
export function topicCreate(id: number | string, data: any) {
    return request({
        url: `group/data/create/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 专题活动 -- 编辑
 */
export function topicUpdate(id: number | string, groupDataId: number | string, data: any) {
    return request({
        url: `group/data/update/${id}/${groupDataId}`,
        method: 'post',
        data,
    });
}

/**
 * @description 专题活动 -- 详情
 */
export function topicDetail(id: number | string) {
    return request({
        url: `group/data/detail/${id}`,
        method: 'get',
    });
}

/**
 * @description 菜单搜索 -- 获取数据
 */
export function getMenuSearchList(data: any) {
    return request({
        url: 'system/menu/getAdminMenusList',
        method: 'post',
        data,
    });
}

/**
 * @description 系统信息 -- 获取数据
 */
export function auth() {
    return request({
        url: 'info',
        method: 'get',
    });
}


/**
 * @description 系统信息 -- 保存系统公用配置项
 * @param {*} key
 * @param {*} data
 */
export function saveSysConfig(key:string, data:any) {
    return request({
        url: `config/save/${key}`,
        method: 'post',
        data,
    });
}

/**
 * @description 系统信息 -- 获取系统公用配置项
 * @param {*} key
 */
export function getSysConfig(key:string) {
    return request({
        url: `config_classify/${key}`,
        method: 'get',
    });
}
